<template>
  <vue-draggable-resizable
    :x="x"
    :y="y"
    :w="w"
    :h="h"
    :z="zIndex"
    :min-height="32"
    :min-width="32"
    :parent="true"
    :lock-aspect-ratio="false"
    class-name="resizable-draggable-container"
    @resizing="onResize"
    @dragging="onDrag"
  >
    <slot/>
  </vue-draggable-resizable>
</template>

<script>
import VueDraggableResizable from 'vue-draggable-resizable';
import './css/ResizableFrame.css';

export default {
  name: 'ResizableContainer',

  components: {
    VueDraggableResizable,
  },

  props: {
    width: {
      type: Number,
      default: 100,
    },
    height: {
      type: Number,
      default: 100,
    },
    xPos: {
      type: Number,
      default: 0,
    },
    yPos: {
      type: Number,
      default: 0,
    },
    zIndex: {
      type: [Number, String],
      default: 'auto',
    },
    parentHeight: {
      type: Number,
      default: null,
    },
    parentWidth: {
      type: Number,
      default: null,
    },
    position: {
      type: String,
      default: '',
    },
  },

  mounted() {
    this.calculateInitPosition();

    this.update();
  },

  data() {
    return {
      w: null,
      h: null,
      x: null,
      y: null,
    };
  },
  methods: {
    onDrag(left, top) {
      this.x = left;
      this.y = top;

      this.update();
    },

    onResize(left, top, width, height) {
      this.x = left;
      this.y = top;
      this.w = width;
      this.h = height;

      this.update();
    },

    update() {
      this.$emit('update', {
        x: this.x,
        y: this.y,
        w: this.w,
        h: this.h,
      });
    },

    calculateInitPosition() {
      if (this.position === '') {
        this.x = this.xPos;
        this.y = this.yPos;
        this.w = this.width;
        this.h = this.height;
      } else {
        switch (this.position) {
          case 'center':
            this.x = 0;
            this.w = this.parentWidth ? (this.parentWidth - 1) : this.width;
            this.h = this.height;
            this.y = this.parentHeight
              ? (this.parentHeight - this.h) / 2
              : 0;
            break;
          default:
        }
      }
    },
  },
};
</script>

<style scoped>
.resizable-draggable-container {
  position: absolute;
  color: white;
  border: #b758e2 dotted 3px;
}
</style>
